/*
 * @Author: your name
 * @Date: 2021-04-27 13:49:19
 * @LastEditTime: 2021-05-04 12:00:18
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \yijiu_shopmall_h5\http.js
 */
import axios from 'axios'
import config from '../../../config.js'

let token = ''

// 添加请求拦截器
let http = function (url, params, token = '', file) {
  let instance = axios.create({
    baseURL: config.liveUrl,
    method: 'post',
    headers: {
      'content-type': 'application/json'
      // "Authori-zation": "Bearer " + token || ''
    },
    timeout: 60000000
  })

  token = token ? token : ''
  let timer = Date.parse(new Date())
  let data
  let path = ''
  if (file) {
    data = params
    path = '/XcxFile/uploadReportImage'
  } else {
    data = {
      content: {
        base: {
          time: timer,
          source: '6',
          equipment: 'xcx',
          token: token,
          version: 'v1.0.0'
        },
        data: {
          method: url,
          ...params
        }
      },
      dataType: 'json',
      lock: '',
      time: timer,
      app_key: 'gprIFZYS5W1YfSzvWV9PmSiJVawWLME1'
    }
    data = JSON.stringify(data)
  }
  return new Promise((resolu, rejec) => {
    instance
      .post(path, data)
      .then(res => {
        resolu(res.data)
      })
      .catch(err => {
        rejec(err)
      })
  })
}

export default http
